<template>

    <div>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">

      <md-toolbar class="toolbr">
        <img :src="foundation" alt="" width="150px" srcset="">
        <div style="flex:1"></div>
        <div class="row">
          <md-button  @click="fetch_data" class="col-xs-3">
            <img style="width:50px;height:40px" :src="sync" alt="">
          </md-button >
          <router-link  to="/info" class="col-xs-3">
            <md-button v-bind:class="{'md-raised':isActive('info')}" class="  link">پنل اطلاعات</md-button>
          </router-link>
          <router-link  to="/register-proposal" class="col-xs-3">
            <md-button v-bind:class="{'md-raised':isActive('register')}" class="link">ثبت پیشنهاد</md-button>
          </router-link>
          <router-link  to="/kuknos-transactions" class="col-xs-3">
            <md-button v-bind:class="{'md-raised':isActive('kuknos-transactions')}" class="link">مشاهده ی تراکنش های ققنوسی</md-button>
          </router-link>


        </div>

      </md-toolbar>
      <vue-progress-bar></vue-progress-bar>

      <router-view></router-view>
    </div>

</template>


<style>
</style>
<script>

  // register globally
  import 'bootstrap/dist/css/bootstrap.css'
  import 'font-awesome/css/font-awesome.min.css'
  import contract from './Contract.json'
  import Web3 from 'web3'
  import {mapActions,mapGetters} from 'vuex';
  import ContractUtils from './contract'
  import dotenv from 'dotenv'
  import foundation from './assets/foundantion.png'
  import sync from './assets/sync.png'
  export default {
    async mounted(){
      dotenv.config();
      const { VUE_APP_BASE_SERVER } = process.env;
      const self= this;

     if (window.ethereum) {
        let web3 = new Web3( ethereum)

        try {
            ethereum.enable()
              .then(async(account)=>{
                    var myContract = new web3.eth.Contract(contract,'0x2ad698760fbde968dae0d29a08cba83ac96ca04b');
                    ContractUtils.setContract(myContract);
                    self.set_contract(true);
                    self.set_web3(web3.utils)
                    self.set_account(account[0])
                  })
                .catch(err=>{
                  this.$toastr('مشکلی پیش آمده')
              })
            
        } catch (error) {
            // User denied account access...
      }
    }
    else{
      alert('خطا')
    }

  }  
      
    ,
    methods:{
      ...mapActions(['set_web3','set_account','set_contract','fetch_data']),
      isActive(path){
        return window.location.href.split('/')[4].includes(path) ;
      }

    },
    data:()=>({
      foundation,
      Voting:{},
      account:"",
      sync,
      web3:{}
    })
  }
</script>
<style scoped>
.toolbr{
  background: rgb(3,127,187);
  background: linear-gradient(90deg, rgba(3,127,187,1) 0%, rgba(43,82,157,1) 94%);
}
.link{
  margin: 1em !important;
  color: white !important;
}
.md-raised{
  border-radius:10px ;
  color: black !important;
}

</style>
